export const residenceTypes = ["India", "NRI"];

export const indiaAddressOptions = {
  "Andhra Pradesh": {
    "Alluri Sitharama Raju": ["Paderu", "Araku Valley", "Chintapalle", "Other"],
    Anakapalli: ["Anakapalli", "Narsipatnam", "Yelamanchili", "Other"],
    Ananthapuramu: ["Anantapur", "Guntakal", "Tadipatri", "Other"],
    Annamayya: ["Madanapalle", "Rayachoti", "Rajampet", "Other"],
    Bapatla: ["Bapatla", "Chirala", "Repalle", "Other"],
    Chittoor: ["Chittoor", "Nagari", "Palamaner", "Other"],
    "Dr. B.R. Ambedkar Konaseema": ["Amalapuram", "Mandapeta", "Ramachandrapuram", "Other"],
    "East Godavari": ["Rajahmundry", "Kovvur", "Nidadavole", "Other"],
    Eluru: ["Eluru", "Nuzvid", "Jangareddygudem", "Other"],
    Guntur: ["Guntur", "Mangalagiri", "Tenali", "Other"],
    Kakinada: ["Kakinada", "Peddapuram", "Samalkota", "Other"],
    Krishna: ["Machilipatnam", "Gudivada", "Avanigadda", "Other"],
    Kurnool: ["Kurnool", "Adoni", "Yemmiganur", "Other"],
    Markapuram: ["Markapuram", "Kanigiri", "Giddalur", "Other"],
    Nandyal: ["Nandyal", "Dhone", "Atmakur", "Other"],
    NTR: ["Vijayawada", "Nandigama", "Tiruvuru", "Other"],
    Palnadu: ["Narasaraopet", "Piduguralla", "Sattenapalle", "Other"],
    "Parvathipuram Manyam": ["Parvathipuram", "Salur", "Palakonda", "Other"],
    Polavaram: ["Rampachodavaram", "Chinturu", "Polavaram", "Other"],
    Prakasam: ["Ongole", "Kandukur", "Darsi", "Other"],
    "Sri Potti Sriramulu Nellore": ["Nellore", "Kavali", "Atmakur", "Other"],
    "Sri Sathya Sai": ["Puttaparthi", "Hindupur", "Dharmavaram", "Other"],
    Srikakulam: ["Srikakulam", "Palasa", "Tekkali", "Other"],
    Tirupati: ["Tirupati", "Srikalahasti", "Puttur", "Other"],
    Visakhapatnam: ["Visakhapatnam", "Bheemunipatnam", "Gajuwaka", "Other"],
    Vizianagaram: ["Vizianagaram", "Bobbili", "Cheepurupalli", "Other"],
    "West Godavari": ["Bhimavaram", "Tadepalligudem", "Tanuku", "Other"],
    "YSR Kadapa": ["Kadapa", "Proddatur", "Pulivendula", "Other"],
    Other: ["Other"],
  },
  Telangana: {
    Adilabad: ["Adilabad", "Utnoor", "Boath", "Other"],
    "Bhadradri Kothagudem": ["Kothagudem", "Bhadrachalam", "Yellandu", "Other"],
    Hanumakonda: ["Hanumakonda", "Kazipet", "Parkal", "Other"],
    Hyderabad: ["Hyderabad", "Secunderabad", "Other"],
    Jagtial: ["Jagtial", "Koratla", "Metpally", "Other"],
    Jangaon: ["Jangaon", "Ghanpur", "Other"],
    "Jayashankar Bhupalpally": ["Bhupalpally", "Kataram", "Other"],
    "Jogulamba Gadwal": ["Gadwal", "Alampur", "Other"],
    Kamareddy: ["Kamareddy", "Banswada", "Yellareddy", "Other"],
    Karimnagar: ["Karimnagar", "Huzurabad", "Jammikunta", "Other"],
    Khammam: ["Khammam", "Madhira", "Sathupalli", "Other"],
    "Kumuram Bheem Asifabad": ["Asifabad", "Kagaznagar", "Other"],
    Mahabubabad: ["Mahabubabad", "Dornakal", "Thorrur", "Other"],
    Mahabubnagar: ["Mahabubnagar", "Jadcherla", "Other"],
    Mancherial: ["Mancherial", "Bellampalli", "Chennur", "Other"],
    Medak: ["Medak", "Narsapur", "Other"],
    "Medchal-Malkajgiri": ["Medchal", "Malkajgiri", "Keesara", "Other"],
    Mulugu: ["Mulugu", "Eturnagaram", "Other"],
    Nagarkurnool: ["Nagarkurnool", "Achampet", "Kalwakurthy", "Other"],
    Nalgonda: ["Nalgonda", "Miryalaguda", "Devarakonda", "Other"],
    Narayanpet: ["Narayanpet", "Kosgi", "Makthal", "Other"],
    Nirmal: ["Nirmal", "Bhainsa", "Khanapur", "Other"],
    Nizamabad: ["Nizamabad", "Bodhan", "Armoor", "Other"],
    Peddapalli: ["Peddapalli", "Ramagundam", "Manthani", "Other"],
    "Rajanna Sircilla": ["Sircilla", "Vemulawada", "Other"],
    Rangareddy: ["Shamshabad", "Ibrahimpatnam", "Chevella", "Other"],
    Sangareddy: ["Sangareddy", "Patancheru", "Zaheerabad", "Other"],
    Siddipet: ["Siddipet", "Gajwel", "Husnabad", "Other"],
    Suryapet: ["Suryapet", "Kodad", "Huzurnagar", "Other"],
    Vikarabad: ["Vikarabad", "Tandur", "Parigi", "Other"],
    Wanaparthy: ["Wanaparthy", "Kothakota", "Other"],
    Warangal: ["Warangal", "Narsampet", "Wardhannapet", "Other"],
    "Yadadri Bhuvanagiri": ["Bhuvanagiri", "Aler", "Choutuppal", "Other"],
    Other: ["Other"],
  },
  Karnataka: {
    Bagalkote: ["Other"],
    Ballari: ["Other"],
    Belagavi: ["Other"],
    "Bengaluru Rural": ["Other"],
    "Bengaluru Urban": ["Other"],
    Bidar: ["Other"],
    Chamarajanagara: ["Other"],
    Chikkaballapura: ["Other"],
    Chikkamagaluru: ["Other"],
    Chitradurga: ["Other"],
    "Dakshina Kannada": ["Other"],
    Davanagere: ["Other"],
    Dharwad: ["Other"],
    Gadag: ["Other"],
    Hassan: ["Other"],
    Haveri: ["Other"],
    Kalaburagi: ["Other"],
    Kodagu: ["Other"],
    Kolar: ["Other"],
    Koppal: ["Other"],
    Mandya: ["Other"],
    Mysuru: ["Other"],
    Raichur: ["Other"],
    Ramanagara: ["Other"],
    Shivamogga: ["Other"],
    Tumakuru: ["Other"],
    Udupi: ["Other"],
    "Uttara Kannada": ["Other"],
    Vijayapura: ["Other"],
    Vijayanagara: ["Other"],
    Yadgir: ["Other"],
    Other: ["Other"],
  },
  Other: {
    Other: ["Other"],
  },
};

export const indiaStates = Object.keys(indiaAddressOptions);
